// frontend/src/charts/palette.js
// Chart colours come from CSS custom properties in index.css (--series-1..8
// and --chart-*), so a theme change is a CSS change only. The fallbacks are
// the same values, used where CSS is not available (unit tests).
//
// The 8 series colours are a validated categorical order: colour-blind
// separation and contrast were checked against the app's card surface
// (#1a1a1a). Order matters; never re-sort or cycle them. A chart with more
// than 8 series shows the first 8 and says so (see echartsOption.js).

export const MAX_SERIES = 8;

/** The same 8 hues stepped for a dark surface (validated against #1a1a1a). */
export const DARK_SERIES = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];
/** The same 8 hues stepped for a light surface (validated against #ffffff; used by light-themed embeds). */
export const LIGHT_SERIES = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];

export const FALLBACK_THEME = {
  series: DARK_SERIES,
  surface: '#1a1a1a',
  text: '#ffffff',
  textSecondary: '#c3c2b7',
  textMuted: '#898781',
  grid: '#2c2c2a',
  axis: '#383835',
};

export const LIGHT_THEME = {
  series: LIGHT_SERIES,
  surface: '#fcfcfb',
  text: '#0b0b0b',
  textSecondary: '#52514e',
  textMuted: '#898781',
  grid: '#e1e0d9',
  axis: '#c3c2b7',
};

const VARS = {
  surface: '--chart-surface',
  text: '--chart-text',
  textSecondary: '--chart-text-secondary',
  textMuted: '--chart-text-muted',
  grid: '--chart-grid',
  axis: '--chart-axis',
};

export function readTheme(el) {
  if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') return FALLBACK_THEME;
  const style = window.getComputedStyle(el || document.documentElement);
  const get = (name, fallback) => (style.getPropertyValue(name) || '').trim() || fallback;
  const theme = { series: FALLBACK_THEME.series.map((c, i) => get(`--series-${i + 1}`, c)) };
  for (const [key, name] of Object.entries(VARS)) theme[key] = get(name, FALLBACK_THEME[key]);
  return theme;
}